import { Modal } from 'react-bootstrap';
import logoImage from "../../assest/images/logo-img.png"
import am1Img from "../../assest/images/am-1.png";
import am2Img from "../../assest/images/am-2.png";
import am3Img from "../../assest/images/am-3.png";
import whiteLogoImage from "../../assest/images/whitelogo.png";

const MultiBancoModal = ({ showMBModal, MBtimeLeft, mbResponse, canceMultibancoPayment }) => {

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };


    return (
        <Modal
            show={showMBModal}
            // onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            className='verification-modal dark_common_modal'
        >
            <Modal.Body>
                <div className="payment-container">
                    <a href="javascript:void(0)" className='comLogo'><img src={logoImage} alt="logo-img" /></a>
                    <a href="javascript:void(0)" className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></a>

                    <div className="amountDetail mt-2">
                        <div className="amountBox">
                            <ul>
                                <li>
                                    <p><span><img src={am1Img} alt="am-1" />Entity</span>{mbResponse?.Entity}</p>
                                    <p><span><img src={am2Img} alt="am-2" />Reference</span>{mbResponse?.Reference}</p>
                                    <p><span><img src={am3Img} alt="am-3" />Amount</span>EUR {mbResponse?.Amount}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="payment-icon5">
                        <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
                            <div className='listloader'></div>
                        </div>
                    </div>

                    <div className="processing-title">Waiting for payment...</div>
                    <div className="processing-loading-text">Please wait while we process your transaction securely.</div>
                    <div className="processing-expire-note mt-2">Your Paymet request will expire in {formatTime(MBtimeLeft)}</div>
                    <button className="cancelRedBtn mt-2" href="javascript:void(0)" onClick={() => canceMultibancoPayment()}>Cancel Booking</button>
                </div>

            </Modal.Body>
        </Modal >
    )
}
export default MultiBancoModal